export default "__VITE_ASSET__BzeheI55__"